// Libraries
import clsx from "clsx";

// Components
import TypographyCell from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";

// Types
import { TUnprocessedVin } from "../../types/dealerTrades";

type TBlockedVinMessageProps = {
	unprocessedVins: TUnprocessedVin[];
};

export default function BlockedVinMessage(props: Readonly<TBlockedVinMessageProps>) {
	const { unprocessedVins } = props;

	return (
		<TypographyCell component={"span"} className="!font-sans !text-[14.5px] !text-default !font-normal">
			Could not complete action for all selected vehicles. Please try again at a later time.
			<br />
			The following GPS device transfer{unprocessedVins.length > 1 ? "s" : ""} {unprocessedVins.length === 1 ? "is" : "are"} still in
			progress:
			<br />
			{unprocessedVins.map((item, index) => {
				const comma = index > 0 ? ", " : "";
				if (item?.vin) {
					return (
						<TypographyCell component={"span"} key={`un-processed-vin-${item?.vin}`} className="!font-bold">
							{comma}
							{item?.vin}
						</TypographyCell>
					);
				}

				return (
					<TypographyCell component={"span"} key={`un-processed-vin-swap-${item?.swap?.vin}-${item?.swap?.partner?.vin}`}>
						{comma}(
						<TypographyCell component={"span"} className="!font-bold">
							{item?.swap?.vin}{" "}
						</TypographyCell>
						swap
						<TypographyCell component={"span"} className={clsx({ "!font-bold": item?.swap?.partner?.isBlocked })}>
							{" "}
							{item?.swap?.partner?.vin}
						</TypographyCell>
						)
					</TypographyCell>
				);
			})}
		</TypographyCell>
	);
}
